import * as actions from './actions';
import * as mutations from './mutations';

const state = {
  cancellationPolicy: '',
  termsAndConditions: '',
  paymentInfo: '',
  pickupInfo: '',
  refundInfo: ''
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
